/* globals axios */

import Vue from 'vue';

Vue.component('cookie-declaration-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {};
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.$nextTick(() => {
            const script = document.createElement('script');
            script.setAttribute('async', true);
            script.setAttribute('src', 'https://consent.cookiebot.com/ba01f68e-0374-4bd5-8f2e-f74ff7df84d7/cd.js');
            script.setAttribute('type', 'application/javascript');
            this.$el.appendChild(script);
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {},
});
